import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import { AnimatePresence } from 'framer-motion';
import React__default from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Toast } from './Toast.js';
import { ToastContext } from './ToastContext.js';
var ToastContainer = styled(Box)(css({
  position: "fixed",
  display: "flex",
  flexDirection: "column",
  left: "50%",
  transform: "translate(-50%, 0)",
  zIndex: "toast"
}));
var ToastManager = function ToastManager(_a) {
  var _b = _a.paddingTop,
    paddingTop = _b === void 0 ? 0 : _b;
  var _c = React__default.useContext(ToastContext),
    toasts = _c.toasts,
    close = _c.close;
  if (typeof document !== "undefined") {
    return ReactDOM.createPortal(React__default.createElement(ToastContainer, {
      top: "".concat(paddingTop + 12, "px")
    }, React__default.createElement(AnimatePresence, null, toasts.map(function (toast) {
      return React__default.createElement(Toast, __assign({}, toast, {
        onClose: function onClose() {
          return close(toast.id);
        },
        key: toast.id
      }));
    }))), document.body);
  }
  return null;
};
export { ToastManager };